package com.trevorwiebe.timesheet.admin.rate.presentation

import com.trevorwiebe.timesheet.core.domain.model.Rate

data class RateState(
    val rates: List<Rate> = emptyList(),
    val showAddEditDialog: Boolean = false,
    val editingRate: Rate? = null,
    val isLoading: Boolean = false,
    val error: String? = null
)
